"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Feedback/Modals/LowRatingReason.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _RadioInput = require('web/components/Form/RadioInput'); var _RadioInput2 = _interopRequireDefault(_RadioInput);

var _Comment = require('./Comment'); var _Comment2 = _interopRequireDefault(_Comment);









const proceedBtnClassName = _classBuilder2.default.call(void 0, 
  "meeting--btn", "meeting--feedback--low-rating-reason--proceed-btn",
)

// Was a PureComponent: memo keeps the shallow props bail-out.
const LowRatingReasonModal = _react.memo.call(void 0, function LowRatingReasonModal ({
  lowRatingReasons, isOpen, onClose, onReasonSubmit, onCommentSubmit,
}) {
  // Seeded once from the first reason, like the class state initialiser.
  // SAFETY: the list is never empty; an empty one throws, as in JS.
  const [currentReason, setCurrentReason] = _react.useState.call(void 0, () => lowRatingReasons[0].value)
  const [isLowRatingCommentModalOpen, setIsLowRatingCommentModalOpen] = _react.useState.call(void 0, false)

  // RadioInput reports its `inputId` ("currentReason"), which the class used
  // as the state key.
  const onReasonChange = _react.useCallback.call(void 0, 
    (_inputId, _error, value) => setCurrentReason(value),
    [],
  )

  const onProceed = () => {
    const reason = lowRatingReasons.find(r => r.value === currentReason)

    onClose()
    if (_optionalChain([reason, 'optionalAccess', _ => _.isExplanationNeeded])) setIsLowRatingCommentModalOpen(true)
    else onReasonSubmit(currentReason)
  }

  const handleCommentSubmit = _react.useCallback.call(void 0, (comment) => {
    onClose()
    onCommentSubmit(comment)
  }, [onClose, onCommentSubmit])

  const handleClose = _react.useCallback.call(void 0, () => {
    onClose()
    onReasonSubmit(null)
  }, [onClose, onReasonSubmit])

  const closeLowRatingCommentModal = _react.useCallback.call(void 0, 
    () => setIsLowRatingCommentModalOpen(false),
    [],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Modal2.default, {
        onClose: handleClose,
        isOpen: isOpen && !isLowRatingCommentModalOpen,
        className: "meeting--feedback--low-rating-reason-modal",
        title: "Sorry about your call"   ,
        size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}

        , _react2.default.createElement('span', { className: "meeting--feedback--low-rating-reason--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "What went wrong?"

        )
        , _react2.default.createElement('div', { className: "meeting--feedback--low-rating-reason--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
          , _react2.default.createElement(_RadioInput2.default, {
            className: "meeting--feedback--low-rating-reason-group",
            inputId: "currentReason",
            options: lowRatingReasons,
            onChange: onReasonChange,
            value: currentReason, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
          )
        )
        , _react2.default.createElement('a', {
          onClick: onProceed,
          className: proceedBtnClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
, "Submit"

        )
      )
      , _react2.default.createElement(_Comment2.default, {
        isOpen: isLowRatingCommentModalOpen,
        onClose: closeLowRatingCommentModal,
        onSubmit: handleCommentSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
      )
    )
  )
})

exports. default = LowRatingReasonModal
